// Client wrapper for /api/packing. Per-player; state is keyed by the
// calling player_id derived from the session cookie.

const TRIP_DEFAULT = 'juneau-2026';

async function jsonOrThrow(res) {
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

export async function fetchPacking({ tripId = TRIP_DEFAULT } = {}) {
  const res = await fetch(`/api/packing?trip_id=${tripId}`, { credentials: 'include' });
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('json')) {
    const err = new Error('api_unavailable');
    err.status = 'api_unavailable';
    throw err;
  }
  return jsonOrThrow(res);
}

export async function togglePackingItem({ tripId = TRIP_DEFAULT, itemId, checked }) {
  const res = await fetch('/api/packing', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ trip_id: tripId, item_id: itemId, checked }),
  });
  return jsonOrThrow(res);
}
